import { GenericLazyString } from '@eventbrite/i18n';
import { CheckoutState } from '../../state';
import { DeepErrorDictionary } from '../../state/form';
import { getRegisteredFields } from './pureSelectors';

export const getFieldsWithValidationErrors = (
    state: CheckoutState,
    formName: keyof CheckoutState['form'],
) => {
    const registeredFields = getRegisteredFields(state, formName);
    const syncErrors = state.form[formName]?.syncErrors;
    const asyncErrors = state.form[formName]?.asyncErrors;

    const getFieldName = (name: string, prefix?: string) =>
        prefix ? `${prefix}.${name}` : name;

    const getErroredFields = (
        errors?: Record<
            string,
            string | GenericLazyString | DeepErrorDictionary
        >,
        currentKeyPath?: string,
    ): Array<string> =>
        Object.entries(errors ?? {}).flatMap<string>(([key, value]) => {
            if (!value) {
                return [];
            }

            const fieldName = getFieldName(key, currentKeyPath);

            return typeof value === 'string' ||
                value instanceof GenericLazyString
                ? [fieldName]
                : getErroredFields(value, fieldName);
        });

    const fieldsFailingSyncValidation = getErroredFields(syncErrors);
    const fieldsFailingAsyncValidation = getErroredFields(asyncErrors);

    const uniqueFailedFields = new Set([
        ...fieldsFailingSyncValidation,
        ...fieldsFailingAsyncValidation,
    ]);

    const failedFields = registeredFields.filter((fieldName) =>
        uniqueFailedFields.has(fieldName),
    );

    return failedFields;
};
